<br>
<br>

<div *ngIf='valid && isBeforeExpired' class="content-align">
    <div class="text-center">
        <p class="text-center">{{'pswd_reset_msg' | translate}} {{maskedEmail}}.{{'confirm_reset_pwd_msg' | translate}}
        </p>
      </div>
    

    <br>
    <br>

    <div class="text-center">
        <button class="btn btn-success" (click)="sendResetPwdOTP()"><em
                class="fas fa-sign-in-alt icon-align"></em>&nbsp;Proceed</button>
    </div>
</div>

<div *ngIf='!valid ||! isBeforeExpired' class="content-align">
    <div class="text-center">
    <p class="text-center">{{'pswd_reset_link_invalid_msg' | translate}}
    </p>
</div>
    <br>
    <br>

    <div class="text-center">
        <button class="btn btn-success" (click)="goToLogin()"><em class="fas fa-sign-in-alt icon-align"></em>&nbsp;Go To
            {{'login' | translate }}</button>
    </div>
</div>